<template>
  <div class="layout-wrapper">
    <TheHeader />

    <div class="mp-container">
      <div class="mp-content-container">
        <div class="mp-content">
          <slot />
        </div>
      </div>

      <div
        class="mp-background-container"
        :style="{
          backgroundImage: `url(${require('@/assets/images/registration-background.svg')})`,
        }"
      />
    </div>

    <portal-target
      name="application-flow-navigator-destination"
      class="navigator"
    ></portal-target>
  </div>
</template>

<script>
export default {
  components: {
    TheHeader: () => import("@/components/header/RegistrationHeader"),
  },
};
</script>

<style scoped lang="scss">
.layout-wrapper {
  min-height: 100vh;
  display: flex;
  flex-wrap: nowrap;
  flex-basis: 0;
  flex-direction: column;

  .mp-container {
    display: flex;
    flex-grow: 1;

    .mp-content-container {
      display: flex;
      flex-basis: 50%;
      padding: 3rem 8rem;
      justify-content: center;

      .mp-content {
        width: 100%;
        max-width: 600px;
      }
    }

    .mp-background-container {
      position: fixed;
      height: 100vh;
      width: 50%;
      left: 50%;
      top: 0;

      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
    }
  }
}

@media only screen and (max-width: 769px) {
  .layout-wrapper {
    .mp-container {
      .mp-content-container {
        flex-basis: 100%;
        padding: 2rem 2rem;
      }

      .mp-background-container {
        display: none;
      }
    }
  }
}
</style>

<style lang="scss">
.content {
  overflow: unset;
}

.header-container {
  position: sticky;
  top: 0;
}
</style>
